// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Trend_wrapper__VJs6B","content":"Trend_content__xs_yD"};